const PER_MONTH = "common.labels.perMonth";
const PER_QUARTER = "common.labels.perQuarter";
const PER_HALF_YEAR = "common.labels.perHalfYear";
const PER_YEAR = "common.labels.perYear";

const QUARTER = 3;
const HALF_YEAR = 6;
const YEAR = 12;

/**
 * i18n-ключ подписи к цене. Приоритет — duration (12/6/3/остальное), иначе
 * старая логика на isOfferAnnual + validityPeriod.
 */
export const getPricePeriodKey = (
  isOfferAnnual?: boolean | null,
  validityPeriod?: number | null,
  duration?: number | null
): string => {
  if (duration !== undefined && duration !== null) {
    if (Number(duration) === YEAR) return PER_YEAR;
    if (Number(duration) === HALF_YEAR) return PER_HALF_YEAR;
    if (Number(duration) === QUARTER) return PER_QUARTER;
    return PER_MONTH;
  }
  if (!isOfferAnnual) return PER_MONTH;
  return Number(validityPeriod) === HALF_YEAR ? PER_HALF_YEAR : PER_YEAR;
};

/**
 * Технический суффикс периода в конце названия промо:
 * "_12M", "_6m", "_3МЕС", "_12" и т.п.
 */
const PERIOD_SUFFIX = /_\d+[A-Za-zА-Яа-яЁё]*\s*$/;

/**
 * Убирает служебный суффикс периода из названия скидки:
 * "Скидка 100%_12M" -> "Скидка 100%".
 *
 * Срезается только суффикс, начинающийся с подчёркивания и цифр, поэтому
 * осмысленные названия с подчёркиванием (например "Промо_лето") не трогаются.
 * Если после обрезки ничего не осталось, возвращаем исходную строку —
 * лучше показать технический код, чем пустую подпись.
 */
export const formatDiscountName = (name?: string | null): string => {
  const source = (name ?? "").trim();
  const stripped = source.replace(PERIOD_SUFFIX, "").trim();
  return stripped || source;
};
